<template>
  <div class="tab-main-markets">
    <div class="retail__markets">
      <SectionSearchSelect
          :title="'Lotteries'"
          @search="handleSearch"
          @select-all="handleSelectAll"
          @deselect-all="handleDeSelectAll"
          :classDownKeyboard="'.first-checkbox'"
          :classDownSelectAll="'.first-checkbox'"
          :classUpKeyboard="'.upByLottery'"
      />
      <SectionTable
          :isShowIconsSort="true"
          @sortAsc="handleSortAscLotteries"
          @sortDesc="handleSortDescLotteries"
          :classKeyboardCheckbox="'first-checkbox'"
          :listData="listGamesToShow"
          :listTitle="listTitleLotteries"
          :classKeyboardLastCheckbox="'.first-number'"
          :classLastItem="'last-checkbox-market'"
          :classFirstItem="'first-checkbox-market'"
          :toClassFirstItem="'.first-checkbox-market'"
          :toClassLastItem="'.last-checkbox-market'"
          @tabNextSection="handleNextSection"
          @changeCheckbox="handleChangeCheckboxGames"
      />
    </div>
    <div class="retail__selection">
      <div class="retail__selection__title">
        Selection
      </div>
      <div
          class="retail__selection__null"
          v-if="!retailMarkets.ballset?.main[1]"
      >
        Make your lottery selection.
      </div>
      <ListNumbers
          v-if="retailMarkets.ballset?.main[1]"
          :key="reloadListNumber"
          :isZeroNumber="retailMarkets.ballset?.main[0]===0"
          :maxPicks="maxPicksMain"
          :minPicks="retailMarkets.ballset?.main[0]"
          :resultsNumberMain="resultsNumberMain"
          :isFocusNumber="isFocusNumber"
          :numbers="retailMarkets.ballset?.main[1] || 0"
          @selectItem="handleSelectItem($event, 'main')"
          :numbersPicked="resultsNumberMain"
          :maxPicksLength="retailMarkets.maxPicks"
          @tabNumbers="handleTabNumbers"
          :numberDisable="resultNumberDisable['main']"
      />
      <ListNumbers
          :key="reloadListNumber"
          :isZeroNumber="retailMarkets.ballset?.extra[0]===0"
          :minPicks="retailMarkets.ballset?.extra[0]"
          v-if="retailMarkets.ballset?.extra.length>0 || 0"
          :maxPicks="maxPicksBonus"
          :resultsNumberAdditional="resultsNumberAdditional"
          :isFocusNumber="isFocusNumber"
          :numbers="retailMarkets.ballset?.extra[1]"
          :isBonusBallTitle="true"
          @selectItem="handleSelectItem($event, 'additional')"
          @tabNumbers="handleTabNumbers"
          :numbersPicked="resultsNumberAdditional"
          :maxPicksLength="this.numberMaxPicksBonus"
          :numberDisable="resultNumberDisable['additional']"
      />
      <div class="retail__selection__results">
        <div>
          <input
              v-if="retailMarkets.ballset?.extra.length>0 && edit"
              ref="inputResultsMain"
              class="retail__selection__result__main retail__selection__result focusable"
              type="text"
              :value="valueNumbersString"
              @keyup.enter="handleEditNumbers($event)"
              v-focus
              @keydown.tab.prevent="handleTabNumbersMain()"
          />
          <input
              v-if="retailMarkets.ballset?.extra.length===0 && edit"
              ref="inputResultsMain"
              class="retail__selection__result__main retail__selection__result focusable"
              type="text"
              :value="valueNumbersString"
              @keyup.enter="handleEditNumbers($event)"
              v-focus
          />
          <div
              class="retail__selection__result__main retail__selection__result focusable"
              v-if="!edit"
              @click="handleTabNumbers"
          >
            <div
                class="retail__selection__result__item"
                v-for="(item, index) in resultsNumberMain"
                :key="index"
            >
              <a>{{ item }}</a>
            </div>
          </div>
        </div>
        <div v-if="retailMarkets.ballset?.extra.length>0 || 0">
          <input
              ref="inputResultsBonus"
              class="retail__selection__result__bonus retail__selection__result focusable"
              type="text"
              v-if="editBonus"
              :value="valueNumbersStringBonus"
              @keyup.enter="handleEditNumbersBonus($event)"
              v-focus
          />
          <div
              class="retail__selection__result__bonus retail__selection__result focusable"
              v-else
              @click="handleTabNumbersMain"
          >
            <div
                class="retail__selection__result__item"
                v-for="(item, index) in resultsNumberAdditional"
                :key="index"
            >
              <a>{{ item }}</a>
            </div>
          </div>
        </div>
        <div class="retail__selection__results__input">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">{{ currency }}</span>
            </div>
            <input
                v-model="betPerLine"
                ref="refBetPerLineQuick"
                data-sn-right=".btn__add-to-betslip"
                data-sn-left=".downDraw"
                type="number"
                class="form-control focusable inputPrice"
                placeholder=""
            >
            <div
                v-if="betPerLine < betMin"
                class="input-group__error"
            >
              Bet min is {{ betMin }}
            </div>
            <div
                v-if="betPerLine > betMax"
                class="input-group__error"
            >
              Bet max is {{ betMax }}
            </div>
          </div>
        </div>
        <div class="retail__selection__results__right">
          <div class="retail__selection__results__quick-add">
            <button
                ref="refButtonQuickAdd"
                type="submit"
                :disabled="resultsNumberMain.length === 0 || !isSelectMarket ||
                 betPerLine > betMax || betPerLine < betMin"
                @click.prevent.stop="handleQuickAdd"
                @keydown.enter.prevent="handleQuickAdd"
                class="btn btn-primary focusable"
            >Quick Add
            </button>
            <div
                v-if="isShowNotifyQuickAdd"
                class="retail__selection__results__quick-add__notify"
            >Bet selection added.
            </div>
          </div>
          <button
              ref="badgeLight"
              @click="handleViewBetSlip"
              @keydown.enter.prevent="handleViewBetSlip"
              class="retail__selection__results__cart focusable"
          >
            <img src="@/assets/images/home/cart.svg"/>
            <span class="badge badge-light">{{ badgeNumber }}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="retail__markets">
      <SectionSearchSelect
          :title="'Markets'"
          @search="handleSearchMarkets"
          @select-all="handleSelectAllMarkets"
          @deselect-all="handleDeSelectAllMarkets"
          :classDownKeyboard="'.second-checkbox'"
          :classDownSelectAll="'.first-checkbox-market-2'"
          :classUpKeyboard="'.first-number'"
      />
      <SectionTable
          :classKeyboardCheckbox="'second-checkbox'"
          :listData="listMarketsToShow"
          :listTitle="listTitleMarkets"
          :classKeyboardLastCheckbox="'.downDraw'"
          :classLastItem="'last-checkbox-market-2'"
          :classFirstItem="'first-checkbox-market-2'"
          :toClassFirstItem="'.first-checkbox-market-2'"
          :toClassLastItem="'.last-checkbox-market-2'"
          @tabNextSection="handleNextSectionMarket"
          @changeCheckbox="handleChangeCheckboxMarkets"
      />
    </div>
    <div class="retail__bet">
      <div class="retail__bet__draws">
        <div class="retail__bet__draws__title retail__title-common">
          DRAWS
        </div>
        <div class="btn-group retail__bet__draws__contents">
          <button
              ref="dropdown"
              @keydown.down.prevent="nextSectionDropdown"
              type="button"
              class="btn btn-outline-primary dropdown-toggle focusable downDraw"
              data-sn-right=".inputPrice"
              data-sn-down=".inputPrice"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{ numberDrawDropdown }}
          </button>
          <ul class="dropdown-menu">
            <li
                v-for="(item, index) in numberDropdown"
                :key="index"
            >
              <div
                  :tabindex='index'
                  v-if="index === numberDropdown-1"
                  class="dropdown-item focusable"
                  id="idDropdownMarket"
                  :class="{active: numberDrawDropdown=== index+1}"
                  data-sn-down=".dropdown-toggle"
                  @keydown.space.stop="handleSelectDrawDropdown(item)"
                  @keydown.enter.stop="handleSelectDrawDropdown(item)"
                  @click="handleSelectDrawDropdown(item)"
              >
                {{ item }}
              </div>
              <div
                  :tabindex='index'
                  v-if="index !== numberDropdown-1 && index !== 0"
                  class="dropdown-item focusable"
                  id="idDropdownMarket1"
                  :class="{active: numberDrawDropdown=== index+1}"
                  @keydown.space.stop="handleSelectDrawDropdown(item)"
                  @keydown.enter.stop="handleSelectDrawDropdown(item)"
                  @click="handleSelectDrawDropdown(item)"
              >
                {{ item }}
              </div>
              <div
                  :tabindex='index'
                  v-if="index !== numberDropdown-1 && index === 0"
                  class="dropdown-item focusable"
                  data-sn-up=".dropdown-toggle"
                  id="idDropdownMarket2"
                  :class="{active: numberDrawDropdown=== index+1}"
                  @keydown.space.stop="handleSelectDrawDropdown(item)"
                  @keydown.enter.stop="handleSelectDrawDropdown(item)"
                  @click="handleSelectDrawDropdown(item)"
              >
                {{ item }}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="retail__bet__bet-per-line">
        <div class="retail__bet__bet-per-line__title retail__title-common">
          BET PER LINE
        </div>
        <div class="retail__bet__bet-per-line__input">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">{{ currency }}</span>
            </div>
            <input
                v-model="betPerLine"
                ref="refBetPerLine"
                data-sn-right=".btn__add-to-betslip"
                data-sn-left=".downDraw"
                type="number"
                class="form-control focusable inputPrice"
                placeholder=""
                aria-label="Username"
                aria-describedby="basic-addon1"
            >
            <div
                v-if="betPerLine < betMin"
                class="input-group__error"
            >
              Bet min is {{ betMin }}
            </div>
            <div
                v-if="betPerLine > betMax"
                class="input-group__error"
            >
              Bet max is {{ betMax }}
            </div>
          </div>
        </div>
      </div>
      <div class="retail__bet__bet-total">
        <div class="retail__bet__bet-total__title retail__title-common">TOTAL</div>
        <div class="retail__bet__bet-total__value">
          {{ currency }} {{ betPerLine * numberDrawDropdown }}
        </div>
      </div>
      <div class="retail__bet__add-to-betslip">
        <button
            @click="handleAddToBetSlip"
            @keydown.enter.prevent="handleAddToBetSlip"
            :disabled="resultsNumberMain.length === 0 || !isSelectMarket ||
             betPerLine > betMax || betPerLine < betMin"
            type="button"
            data-sn-down=".button-betslip-common"
            data-sn-left=".inputPrice"
            data-sn-right=".inputPrice"
            class="btn btn-primary btn__add-to-betslip focusable"
        >ADD TO BETSLIP
        </button>
      </div>
    </div>
    <ModalCommon
        v-if="showModalBetslip"
        @close="handleCloseYourbetslip"
        @login="handleLogin"
        @process-bet="processBetslipTransat"
        @book-a-bet="handleBookABet"
    >
      <YourBetslip
          @print="handlePrint"
          :isShowPrint="printBet"
          :data-betslip="listDataBetslipsRetail"
          v-bind:commonStake="commonStake"
          v-bind:totalStake="totalStake"
          :loading="loadingProcessBet"
          :loading-boot-a-bet="loadingBootABet"
          :is-disable-process-bet="isDisableProcessBet"
          :is-show-error-expired="isShowErrorExpired"
          :is-show-res-book-a-bet="isShowResBookABet"
          :booking-code-boot-a-bet="bookingCodeBootABet"
          @changeStake="handleChangeStake"
          @removeItemBetslip="handleRemoveItemBetslip"
          @removeAllBetslip="handleRemoveAllBetslips"
          @removeDrawsExpired="removeDrawsExpired"
          @moveToNextDraw="moveToNextDraw"
          @addClassModalClass="handleToggleClassModal"
      />
    </ModalCommon>
  </div>

</template>

<script>
import SectionSearchSelect from '@/components/common/retail-common/section-search-select.vue';
import SectionTable from '@/components/common/retail-common/section-table.vue';
import ListNumbers from '@/components/common/ball/list-numbers.vue';
import YourBetslip from "../ticket/betslip/YourBetslipRetail";
import ModalCommon from '@/components/common/modal/modal-common.vue';
import GameService from "@/services/game.service";
import RetailService from "@/services/retail.service";
import YourBetslipMixinRetail from "../../mixins/betslip/your-betslip-retail-mixin";
import moment from "moment";

// const CURRENCY_CODE = process.env.VUE_APP_CURRENCY_CODE;

export default {
  mixins: [YourBetslipMixinRetail],
  components: {
    SectionSearchSelect,
    SectionTable,
    ListNumbers,
    YourBetslip,
    ModalCommon
  },
  data() {
    return {
      value: '',
      edit: false,
      editBonus: false,
      valueNumbersString: '',
      valueNumbersStringBonus: '',
      currency: this.$store.state.currencyCode,
      isFocusNumber: false,
      numberDropdown: 0,
      reloadListNumber: false,
      optionsRadio: [
        {
          isCheck: true,
          name: 'dataRadio',
          value: 'by_lottery',
          title: 'By Lottery '
        },
        {
          isCheck: false,
          name: 'dataRadio',
          value: 'by_selection',
          title: 'By Selection '
        }
      ],
      resultsNumberMain: [],
      resultsNumberAdditional: [],
      numberListMain: 90,
      listTitleLotteries: ['Select', 'Lottery', 'Next Draw'],
      listTitleMarkets: ['Select', 'Market'],
      listMarkets: [],
      listMarketsToShow: [],
      numberListMaiBonus: 20,
      numberDrawDropdown: 1,
      retailMarkets: {},
      maxPicksMain: false,
      maxPicksBonus: false,
      betPerLine: 0,
      totalBets: 0,
      marketIndicators: {},
      bets: [],
      isSelectMarket: false,
      resultNumberDisable: {},
      numberMaxPicksBonus: 1,
    }
  },
  created() {
    const parameters = this.$route.query
    if (parameters) {
      this.$store.dispatch('initDataCustomer', parameters)
    }
  },
  beforeMount() {
    this.getInitialLoad('main');
  },
  mounted() {
    this.initBadgeNumber();
  },
  directives: {
    focus: {
      inserted(el) {
        this.$nextTick(() => el.focus())
      }
    }
  },
  computed: {
    badgeNumber() {
      return this.$store.state.badgeNumberRetail
    }
  },
  watch: {
    resultsNumberMain: {
      handler(val) {
        let valueString = "";
        val.forEach((item, index) => {
          if (index + 1 >= val.length) {
            valueString = valueString + item;
          } else {
            valueString = valueString + item + ",";
          }
        })
        this.valueNumbersString = valueString;
      },
      deep: true
    },
    resultsNumberAdditional: {
      handler(val) {
        let valueString = "";
        val.forEach((item, index) => {
          if (index + 1 >= val.length) {
            valueString = valueString + item;
          } else {
            valueString = valueString + item + ",";
          }
        })
        this.valueNumbersStringBonus = valueString;
      },
      deep: true
    },
    settings(val) {
      if (val) {
        this.accountSettings = val;
        if (Number(val.bet_default) > 0) {
          this.betPerLine = Number(val.bet_default);
        }
        if (Number(val.bet_min) > 0 && this.betPerLine < Number(val.bet_min)) {
          this.betPerLine = Number(val.bet_min);
        }
      } else {
        if (this.betPerLine < 0) {
          this.betPerLine = 0;
        }
      }
    },
    listMarketsToShow: {
      handler(val) {
        this.isSelectMarket = val.some(item => item.isSelect === true);
      },
      deep: true
    }
  },
  methods: {
    initBadgeNumber() {
      let yourBetslipStorage = localStorage.getItem('yourBetslipRetail')
      if (yourBetslipStorage) {
        yourBetslipStorage = JSON.parse(yourBetslipStorage)
        this.$store.dispatch('changeBadgeNumberRetail', yourBetslipStorage.length);
      }
    },
    handleTabNumbers() {
      this.edit = true;
      this.$nextTick(() => this.$refs.inputResultsMain.focus())
    },
    handleTabNumbersMain() {
      this.editBonus = true;
      this.$nextTick(() => this.$refs.inputResultsBonus.focus())
    },
    handleEditNumbers(event) {
      this.valueNumbersString = event.target.value;
      this.edit = false;
      this.resultsNumberMain = this.valueNumbersString
          .split(',')
          .map((e) => Number(e));
      this.resultsNumberMain = this.resultsNumberMain.filter(item => item <= this.retailMarkets.ballset?.main[1]);
      this.resultsNumberMain.forEach((item, index, arr) => {
        if (index + 1 > this.retailMarkets.maxPicks || item < this.retailMarkets.ballset?.main[0]) {
          arr.splice(index, 1);
        }
      })
      this.resultsNumberMain = this.resultsNumberMain.filter((item, pos) => {
        return this.resultsNumberMain.indexOf(item) === pos;
      })
      this.handleActiveCheckboxMarkets();
      this.$refs.refButtonQuickAdd.focus();
      this.handleCheckDisableNumber(this.resultsNumberMain, 'main', true);
    },
    handleEditNumbersBonus(event) {
      this.valueNumbersStringBonus = event.target.value;
      if (this.valueNumbersStringBonus) {
        this.editBonus = false;
        this.resultsNumberAdditional = this.valueNumbersStringBonus
            .split(',')
            .map((e) => Number(e))
            .filter((i) => i <= this.retailMarkets.ballset?.extra[1] && i >= this.retailMarkets.ballset?.extra[0])
        this.resultsNumberAdditional = this.resultsNumberAdditional.filter((item, index) => index === 0);
      }
      this.handleActiveCheckboxMarkets();
      this.$refs.refButtonQuickAdd.focus();
      this.handleCheckDisableNumber(this.resultsNumberAdditional, 'additional', true);
    },
    formatDateTime(time) {
      return moment(time, "yyyy-MM-dd HH:mm:ss").toDate();
    },
    handleSortAscLotteries(value) {
      if (value === 'Lottery') {
        this.listGamesToShow = this.listGames.sort((a, b) => a.name.localeCompare(b.name));
      }
      if (value === 'Select') {
        this.listGamesToShow = this.listGames.sort((a, b) => {
          return b.isSelect - a.isSelect;
        })
      }
      if (value === 'Next Draw') {
        this.listGamesToShow = this.listGames.sort((a, b) => {
          return this.formatDateTime(b.cutoff) - this.formatDateTime(a.cutoff);
        })
      }
    },
    handleSortDescLotteries(value) {
      if (value === 'Lottery') {
        this.listGamesToShow = this.listGames.sort((a, b) => b.name.localeCompare(a.name));
      }
      if (value === 'Select') {
        this.listGamesToShow = this.listGames.sort((a, b) => {
          return a.isSelect - b.isSelect;
        })
      }
      if (value === 'Next Draw') {
        this.listGamesToShow = this.listGames.sort((a, b) => {
          return this.formatDateTime(a.cutoff) - this.formatDateTime(b.cutoff);
        })
      }
    },
    handleChangeCheckboxMarketsQuickAdd(data) {
      for (const [key, value] of Object.entries(this.marketIndicators)) {
        if (Number(data.keyMarket && data.keyMarket) === Number(key)) {
          Object.keys(value).forEach(key => {
            if (key === data.value) {
              value[key] = value[key] !== true;
            } else {
              value[key] = false;
            }
          });
        } else {
          Object.keys(value).forEach(key => {
            value[key] = false;
          });
        }
      }
    },
    handleChangeCheckboxMarkets(data) {
      for (const [key, value] of Object.entries(this.marketIndicators)) {
        if (Number(data.data.keyMarket) === Number(key)) {
          Object.keys(value).forEach(key => {
            if (key === data.data.value) {
              value[key] = value[key] !== true;
            } else {
              if (typeof (value[key]) === "string") {
                value[key] = false;
              }
            }
          });
        } else {
          Object.keys(value).forEach(key => {
            if (typeof (value[key]) === "string") {
              value[key] = false;
            }
          });
        }
      }
    },
    handleSelectAllMarkets() {
      for (const [_, value] of Object.entries(this.marketIndicators)) {
        Object.keys(value).forEach(key => {
          if (this.listMarketsToShow.some(e => e.value === key)) {
            this.listMarketsToShow.map(item => {
              if (item.isDisable === false && item.value === key) {
                value[key] = true;
                item.isSelect = true
              } else {
                if (item.value === key) {
                  value[key] = false;
                }
              }
            })
          }
        });
      }
    },
    handleDeSelectAllMarkets() {
      for (const [_, value] of Object.entries(this.marketIndicators)) {
        Object.keys(value).forEach(key => {
          if (this.listMarketsToShow.some(e => e.value === key)) {
            this.listMarketsToShow.map(item => {
              value[key] = false;
              item.isSelect = false;
            })
          }
        });
      }
      this.listMarketsToShow = this.listMarkets;
    },
    handleChangeCheckboxGames(data) {
      if (data.data.isSelect === true) {
        this.gamesSlug.push(data.data.gameSlug)
        this.getRetailMarkets(this.gamesSlug);
      } else {
        this.gamesSlug = this.gamesSlug.filter(e => e !== data.data.gameSlug);
        this.getRetailMarkets(this.gamesSlug);
      }
      this.listMarkets = [];
      this.listMarketsToShow = [];
    },
    getRetailMarkets(games) {
      this.listMarkets = [];
      this.listMarketsToShow = [];
      this.retailMarkets = {};
      RetailService.apiGetRetailMarkets(games).then(res => {
        if (res.marketIndicators) {
          this.marketIndicators = res.marketIndicators;
          // this.resultsNumberMain = [];
          // this.resultsNumberAdditional = [];
          this.retailMarkets = res;
          for (const key in this.resultNumberDisable) {
            if (Array.isArray(this.resultNumberDisable[key])) {
              this.resultNumberDisable[key] = this.resultNumberDisable[key].filter(obj => !obj.disable)
            }
          }
          this.resultsNumberMain.forEach((item, index, arr) => {
            if (index + 1 > this.retailMarkets.maxPicks) {
              arr.splice(index, 1);
            }
          })
          this.resultsNumberMain = this.resultsNumberMain.filter(item => item <= this.retailMarkets.ballset?.main[1]);
          for (const [keyMarket, item] of Object.entries(res.marketIndicators)) {
            for (const [key, market] of Object.entries(item)) {
              const valueMarkets = {
                keyMarket: keyMarket,
                isSelect: false,
                market: market,
                number: Number(market.charAt(0)),
                bonus: market.includes("powerball") || market.includes("bonus"),
                value: key
              }
              this.listMarkets.push(valueMarkets);
              this.listMarketsToShow.push(valueMarkets);
            }
          }
          this.numberDropdown = res.availableDraws;
          this.listMarkets.map(item => {
            item.isDisable = true;
          })
          this.handleActiveCheckboxMarkets();
          if (this.retailMarkets?.drum === 'same' && (this.retailMarkets?.ballset?.extra?.length || 0) > 0) {
            this.resultNumberDisable = {};
            this.handleCheckDisableNumber(this.resultsNumberMain, 'main', true);
            this.handleCheckDisableNumber(this.resultsNumberAdditional, 'additional', true);
          }
        } else {
          this.retailMarkets = [];
          this.numberDropdown = 1;
        }
      })
    },
    nextSectionDropdown() {
      setTimeout(() => {
        this.$refs.dropdown.click();
        this.$refs.refBetPerLine.focus();
      },)
    },
    handleNextSection() {
      this.isFocusNumber = !this.isFocusNumber;
    },
    handleNextSectionMarket() {
      this.$refs.dropdown.focus();
    },
    handleSelectDrawDropdown(number) {
      this.numberDrawDropdown = number;
      this.$refs.dropdown.click();
      this.$refs.refBetPerLine.focus();
    },
    handleLogin() {
      this.showModalBetslip = false;
      this.$router.push('Login')
    },
    handleQuickAdd() {
      this.handleAddToBetSlip('quick-add');
      this.$refs.badgeLight.focus();
    },
    handleAddToBetSlip(type) {
      this.listBetslipsRetail.push(
          {
            selections: this.marketIndicators,
            games: this.gamesSlug,
            stake: this.$filters.formatNumber(Number(this.betPerLine)),
            draws: this.numberDrawDropdown,
            numbers: [this.resultsNumberMain, this.resultsNumberAdditional],
          }
      );
      this.reloadListNumber = true;
      this.resultsNumberMain = [];
      this.resultsNumberAdditional = [];
      this.resultNumberDisable = {};
      this.$store.dispatch('addDataToCartRetail', this.listBetslipsRetail);
      localStorage.setItem('listBetslipsRetail', JSON.stringify(this.listBetslipsRetail))
      if (type !== 'quick-add') {
        this.showModalBetslip = true;
        this.handleProcessBetRetail();
      } else {
        this.handleProcessBetRetail('quick-add');
      }
      this.handleDeSelectAllMarkets();
      this.listMarketsToShow.map(item => {
        item.isDisable = true;
      })
    },
    handleSelectItem(number, type) {
      if (type === 'main') {
        if (this.resultNumberDisable['main']?.some(item => item.number === number && item.disable)) return;
        if (this.resultsNumberMain.includes(number)) {
          this.maxPicksMain = false;
          this.resultsNumberMain = this.resultsNumberMain.filter(item => item !== number);
        } else {
          if (this.resultsNumberMain.length + 1 > this.retailMarkets.maxPicks) {
            this.maxPicksMain = true;
          } else {
            this.maxPicksMain = false;
            this.resultsNumberMain.push(number);
          }
        }
      } else {
        if (this.resultNumberDisable['additional']?.some(item => item.number === number && item.disable)) return;
        if (this.resultsNumberAdditional.includes(number)) {
          this.resultsNumberAdditional = this.resultsNumberAdditional.filter(item => item !== number);
        } else {
          if (this.resultsNumberAdditional.length + 1 >= this.retailMarkets.maxPicks) {
            this.maxPicksBonus = true;
          } else {
            this.resultsNumberAdditional.push(number);
          }
        }
      }
      this.handleActiveCheckboxMarkets(type);
      this.handleCheckDisableNumber(number, type)
    },
    handleCheckDisableNumber(number, type, editNumber = false) {
      if (!(this.retailMarkets?.drum === 'same' && (this.retailMarkets?.ballset?.extra?.length || 0) > 0)) return;
      this.resultNumberDisable[type] ||= [];
      const oppositeType = type === 'main' ? 'additional' : 'main';
      // handle number editing function
      if (editNumber) {
        const filterNumberDisable = (arr, arrDisable) => {
          const numberActive = arr.map((item) => ({number: item, disable: true}));
          const numberFilterDisable = arrDisable.filter(item => !item?.disable);
          return [...numberFilterDisable, ...numberActive];
        }
        const filterNumberActive = (arr, arrActive) => {
          const numberActive = arr.map((item) => ({number: item, disable: false}));
          const numberFilterActive = arrActive.filter(item => item?.disable);
          return [...numberFilterActive, ...numberActive];
        }
        if (type === 'main') {
          this.resultsNumberMain = number.filter(item => {
            const hasMatch = this.resultNumberDisable['main']?.some(e => e?.disable && e?.number === item);
            return !hasMatch;
          });
          this.resultNumberDisable['main'] = filterNumberActive(this.resultsNumberMain, this.resultNumberDisable['main'])
          this.resultNumberDisable[oppositeType] = filterNumberDisable(this.resultsNumberMain, this.resultNumberDisable[oppositeType] || [])
        } else {
          this.resultsNumberAdditional = number.filter(item => {
            const hasMatch = this.resultNumberDisable['additional']?.some(e => e?.disable && e?.number === item);
            return !hasMatch;
          });
          this.resultNumberDisable['additional'] = filterNumberActive(this.resultsNumberAdditional, this.resultNumberDisable['additional'])
          this.resultNumberDisable[oppositeType] = filterNumberDisable(this.resultsNumberAdditional, this.resultNumberDisable[oppositeType] || [])
        }
        return;
      }

      // handle click number
      const existingIndex = this.resultNumberDisable[type].findIndex(e => e?.number === number);
      if (existingIndex !== -1) {

        ['main', 'additional'].forEach(key => {
          const index = this.resultNumberDisable[key].findIndex(item => item.number === number);
          if (index !== -1) {
            this.resultNumberDisable[key].splice(index, 1);
          }
        });
      } else {
        this.resultNumberDisable[type].push({number: number, disable: false});
        this.resultNumberDisable[oppositeType] ||= [];
        this.resultNumberDisable[oppositeType].push({number: number, disable: true});
      }
    },
    handleActiveCheckboxMarkets(type) {
      this.listMarkets.map((item, index) => {
        if (this.resultsNumberMain.length > 0) {
          if (item.number === this.resultsNumberMain.length) {
            item.index = index;
            if (item.bonus === true) {
              // item.isSelect = true;
            }
          } else {
            // item.isSelect = false;
            item.index = index;
          }
          if (item.number <= this.resultsNumberMain.length) {
            if (this.resultsNumberAdditional.length > 0 && item.bonus) {
              item.isDisable = false;
            } else {
              item.isDisable = item.number > this.resultsNumberMain.length;
            }
            if (!item.bonus) {
              item.isDisable = false;
            }
          } else {
            item.isDisable = true;
          }
          if (this.retailMarkets.ballset?.extra.length === 0) {
            if (this.resultsNumberMain.length > 0) {
              if (item.market === "power ball"
                  || item.market === "bonus ball") {
                item.isDisable = false;
              }
            }
          } else {
            if (this.resultsNumberAdditional.length > 0) {
              if (item.market === "power ball"
                  || item.market === "bonus ball") {
                item.isDisable = false;
              }
            }
          }
          if (item.market === "Bonus ball bet (different drum as standard numbers)"
              || item.market === "Bonus ball bet (same drum as standard numbers)"
              || item.market === "Ball not drawn excluding bonus") {
            item.isDisable = false;
          }
        } else {
          item.isDisable = true;
        }
      })
      // const items = this.listMarkets.filter(object => object.isAutoCheck === true);
      // const listAutoCheck = items.map(object => {
      //   return object.index;
      // });
      // const max = Math.max(...listAutoCheck);
      // console.log('max', max);
      this.listMarkets.map((item) => {
        if (item.isSelect === true) {
          if (type !== 'additional') {
            this.handleChangeCheckboxMarketsQuickAdd(item);
          }
          // this.handleChangeCheckboxMarkets({data: item});
        } else {
          item.isSelect = false;
        }
      })
      this.listMarketsToShow = this.listMarkets;
    },
    handleSelectAll() {
      this.listGamesToShow.forEach(item => {
        item.isSelect = true
        this.gamesSlug.push(item.gameSlug);
      });
      this.getRetailMarkets(this.gamesSlug);
    },
    handleDeSelectAll() {
      this.listGamesToShow.forEach(item => item.isSelect = false);
      this.listGames.forEach(item => item.isSelect = false);
      this.listGamesToShow = this.listGames;
      this.gamesSlug = [];
      this.getRetailMarkets();
    },
    trimString(s) {
      let l = 0, r = s.length - 1;
      while (l < s.length && s[l] === ' ') l++;
      while (r > l && s[r] === ' ') r -= 1;
      return s.substring(l, r + 1);
    },
    handleSearch(searchKey) {
      const dataSearch = this.trimString(searchKey);
      if (dataSearch !== '') {
        this.listGamesToShow = this.listGames.filter(obj => Object.values(obj).some(val => {
          if (typeof val === 'string') {
            return val.toLowerCase().includes(dataSearch.toLowerCase())
          }
        }));
      } else {
        this.listGamesToShow = this.listGames;
      }
    },
    handleSearchMarkets(data) {
      const dataSearch = this.trimString(data);
      if (dataSearch !== '') {
        this.listMarketsToShow = this.listMarkets.filter(obj => Object.values(obj).some(val => {
          if (typeof val === 'string') {
            return val.toLowerCase().includes(dataSearch.toLowerCase())
          }
        }));
      } else {
        this.listMarketsToShow = this.listMarkets;
      }
    },
  }
}
</script>

<style scoped lang="scss" src="@/assets/scss/retail/tab-main-markets.scss"/>
